/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getPostThreadOtherV2.defs.js'
export * as $defs from './getPostThreadOtherV2.defs.js'
